"use strict";

exports.__esModule = true;
exports.TPA_EXPERIMENTS = void 0;
const TPA_EXPERIMENTS = exports.TPA_EXPERIMENTS = {
  USE_BLOCKS_PLAN_LIST_WIDGET: 'specs.membership.UseBlocksPlanListWidget',
  USE_BLOCKS_PACKAGE_PICKER_PAGE: 'specs.membership.UseBlocksPackagePickerPage',
  FORCE_MEMBERS_AREA_INSTALL: 'specs.membership.ForceMemberAreaInstall',
  FORCE_MEMBERS_AREA_NO_INSTALL: 'specs.membership.ForceMemberAreaNoInstall',
  INSTALL_SPLIT_PAGES: 'specs.membership.InstallSplitPages',
  BLOCKS_SET_CONTROLLER_STATE_ON_LOAD: 'specs.membership.BlocksSetControllerStateOnLoad',
  ROUTER: 'specs.membership.EnableRouter',
  ROUTER_MIGRATION: 'specs.membership.RouterMigration',
  ADDONS_PANEL_MODAL_HEIGHT: 'specs.membership.AddonsPanelModalHeight',
  DATE_LOCALIZATION: 'specs.membership.DateLocalization',
  SETUP_FEE: 'specs.membership.SetupFeeLiveSite',
  USE_CURRENCY_FORMATTER: 'specs.membership.useCurrencyFormatterInPresenter',
  REMOVE_PLAN_LIMIT_TPA_WIDGET_SETTINGS: 'specs.membership.RemovePlanLimitTPAWidgetSettings',
  ROUTE_PAYWALL: 'specs.membership.RoutePaywall',
  USE_WARM_UP_DATA_BLOCKS: 'specs.membership.UseWarmUpDataInBlocks'
};
//# sourceMappingURL=tpa.js.map